// extracted by mini-css-extract-plugin
module.exports = {"word":"b8dd330f047a597e7263444dd9664470"};